var $e303237a88064673$exports = {};
$e303237a88064673$exports = {
    "alert": `Alert\u{103}`,
    "dismiss": `Revocare`
};


export {$e303237a88064673$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
